// extracted by mini-css-extract-plugin
module.exports = {"inputDark":"checkbox_inputDark__3CyXX","header":"checkbox_header__2UEZu","label":"checkbox_label__3xsz6"};